import $api from '@/api'
import $store from '@/store'
import { lang } from '@/i18n'

// 域名组
export async function useDomainGroups() {
  try {
    const res = await $api['hooks/domainGroupList']()
    return res?.code === 200 && res?.data?.length ? res.data : []
  } catch (error) {
    console.warn(new Error(`useDomainGroups: ${error}`))
  }
}

// 客户套餐
export async function usePackageIds() {
  try {
    const res = await $api['hooks/packageGetAllId']()
    return res?.code === 200 && res?.data?.length ? res.data : []
  } catch (error) {
    console.warn(new Error(`usePackageIds: ${error}`))
  }
}

export async function usePackagePrice() {
  try {
    const res = await $api['hooks/getPackagePrice']()
    return res?.code === 200 && res?.data?.length ? res.data : []
  } catch (error) {
    console.warn(new Error(`usePackagePrice: ${error}`))
  }
}

export async function useTransClientList(params) {
  try {
    const finalParams = Object.assign({
      username: $store.state.csec.sessionScope.parentUser || $store.state.csec.sessionScope.mainUser
    }, params)
    const res = await $api['hooks/getTransClientList'](finalParams)
    return res?.code === 200 && res?.data?.length ? res.data : []
  } catch (error) {
    console.warn(new Error(`useTransClientList: ${error}`))
  }
}

export async function useAllBasePackage() {
  try {
    const res = await $api['hooks/allBasePackage']()
    return res?.code === 200 && res?.data?.length ? res.data : []
  } catch (error) {
    console.warn(new Error(`useAllBasePackage: ${error}`))
  }
}

export async function usePackageDetail(packageId) {
  try {
    const res = await $api['hooks/getPackageDetail']({ packageId })
    return res?.code === 200 ? res.data : {}
  } catch (error) {
    console.warn(new Error(`usePackageDetail: ${error}`))
  }
}

export async function useSelection(type) {
  try {
    const res = await $api['common/getSelectOptions']({ type })
    if (res && res.code === 200) {
      return  res.data.map(item => {
        return {
          label: lang === 'cn_CN' ? item.value : item.valueEn,
          value: item.dictKey
        }
      })
    }else {
      return  []
    }
  } catch (error) {
    console.warn(new Error(`useSelection: ${error}`))
  }
}
